export enum BuddyMessageFeedbackReaction {
    'LIKE' = 'LIKE',
    'DISLIKE' = 'DISLIKE',
    'NONE' = 'NONE',
}
